import React from "react";
import Page from "../../components/Page";
import { Icon, Button, Breadcrumb, Responsive, Message } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { get, post } from "../../util/api";
import {
  getFilterOptions,
  templateCacheControl,
  SetUp,
} from "../../components/CampaingHelpers";
import { Formik, Form } from "formik";
import { FilterItem, TriggerSelector } from "../../components/Selector";
import { MaterialInput } from "../../components/Helpers";
import { MyDivider } from "../../components/FormikInput";
import V2Editor from "../../components/SimpleCodeEditor";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
// eslint-disable-next-line
import styled from "styled-components/macro";
import _ from "lodash";

const DEFINITION_TYPE = "action";

const MOCK_CODE = {
  html: '<div id="discount-notification" class="notification-card">\n  <button class="notification-close" aria-label="Kapat">\n    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">\n      <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>\n    </svg>\n  </button>\n  <div class="notification-content">\n    <div class="notification-icon">\n      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">\n        <path d="M18 8C18 6.4087 17.3679 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88258 2.63214 7.75736 3.75736C6.63214 4.88258 6 6.4087 6 8C6 15 3 17 3 17H21C21 17 18 15 18 8Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\n        <path d="M13.73 21C13.5542 21.3031 13.3019 21.5547 12.9982 21.7295C12.6946 21.9044 12.3504 21.9965 12 21.9965C11.6496 21.9965 11.3054 21.9044 11.0018 21.7295C10.6982 21.5547 10.4458 21.3031 10.27 21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\n      </svg>\n    </div>\n    <div class="notification-text">\n      <h3 class="notification-title">Özel İndirim!</h3>\n      <p class="notification-message">Kaban kategorisinde tüm ürünlerde <strong>%20 indirim</strong> var</p>\n    </div>\n  </div>\n</div>',
  css: "#discount-notification {\n  position: fixed;\n  top: 20px;\n  right: 20px;\n  background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);\n  color: white;\n  border-radius: 12px;\n  padding: 20px;\n  box-shadow: 0 8px 24px rgba(37, 99, 235, 0.25);\n  max-width: 360px;\n  z-index: 999999;\n  animation: slideIn 0.4s ease-out;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n@keyframes slideIn {\n  from {\n    transform: translateX(400px);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n@keyframes slideOut {\n  from {\n    transform: translateX(0);\n    opacity: 1;\n  }\n  to {\n    transform: translateX(400px);\n    opacity: 0;\n  }\n}\n\n.notification-card.closing {\n  animation: slideOut 0.3s ease-in forwards;\n}\n\n.notification-close {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  background: rgba(255, 255, 255, 0.15);\n  border: none;\n  border-radius: 50%;\n  width: 28px;\n  height: 28px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  transition: background 0.2s;\n}\n\n.notification-close:hover {\n  background: rgba(255, 255, 255, 0.25);\n}\n\n.notification-content {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n}\n\n.notification-icon {\n  background: rgba(255, 255, 255, 0.15);\n  border-radius: 50%;\n  width: 48px;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  animation: bellRing 2s ease-in-out infinite;\n}\n\n@keyframes bellRing {\n  0%, 100% { transform: rotate(0deg); }\n  10%, 30% { transform: rotate(-10deg); }\n  20%, 40% { transform: rotate(10deg); }\n  50% { transform: rotate(0deg); }\n}\n\n.notification-text {\n  flex: 1;\n  padding-right: 20px;\n}\n\n.notification-title {\n  margin: 0 0 8px 0;\n  font-size: 18px;\n  font-weight: 700;\n  letter-spacing: -0.3px;\n}\n\n.notification-message {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.5;\n  opacity: 0.95;\n}\n\n.notification-message strong {\n  font-weight: 700;\n  font-size: 16px;\n}\n\n@media (max-width: 480px) {\n  #discount-notification {\n    top: 10px;\n    right: 10px;\n    left: 10px;\n    max-width: none;\n    padding: 16px;\n  }\n  \n  .notification-content {\n    gap: 12px;\n  }\n  \n  .notification-icon {\n    width: 40px;\n    height: 40px;\n  }\n  \n  .notification-icon svg {\n    width: 20px;\n    height: 20px;\n  }\n  \n  .notification-title {\n    font-size: 16px;\n  }\n  \n  .notification-message {\n    font-size: 13px;\n  }\n  \n  .notification-message strong {\n    font-size: 14px;\n  }\n}",
  js: "(function() {\n  const notification = document.getElementById('discount-notification');\n  const closeButton = notification.querySelector('.notification-close');\n  \n  // Kapatma butonu\n  closeButton.addEventListener('click', function() {\n    notification.classList.add('closing');\n    setTimeout(function() {\n      notification.style.display = 'none';\n    }, 300);\n  });\n  \n  // 10 saniye sonra otomatik kaybol\n  setTimeout(function() {\n    if (notification.style.display !== 'none') {\n      notification.classList.add('closing');\n      setTimeout(function() {\n        notification.style.display = 'none';\n      }, 300);\n    }\n  }, 10000);\n})();",
};

function ChatMessage({ role, content, isGenerating }) {
  return (
    <div className={`ai-chat-message ${role}`}>
      {content}
      {isGenerating && role === "assistant" && (
        <div className="ai-loading-dots">
          <span />
          <span />
          <span />
        </div>
      )}
    </div>
  );
}

function PreviewToolbar({
  previewMode,
  showCode,
  onPreviewMode,
  onToggleCode,
  onReplay,
  t,
}) {
  return (
    <div className="ai-preview-toolbar">
      <Button.Group size="mini">
        <Button
          active={previewMode === "desktop"}
          onClick={() => onPreviewMode("desktop")}
        >
          <Icon name="desktop" /> {t("AiDesktop")}
        </Button>
        <Button
          active={previewMode === "mobile"}
          onClick={() => onPreviewMode("mobile")}
        >
          <Icon name="mobile alternate" /> {t("AiMobile")}
        </Button>
      </Button.Group>
      <div>
        <Button size="mini" basic color="blue" onClick={onReplay}>
          <Icon name="redo" /> {t("AiReplay")}
        </Button>
        <Button size="mini" toggle active={showCode} onClick={onToggleCode}>
          <Icon name="code" /> {t("AiCodeView")}
        </Button>
      </div>
    </div>
  );
}

function CodeEditor({
  activeTab,
  onTabChange,
  currentCode,
  onCodeChange,
  onApply,
  t,
}) {
  const tabs = [
    { key: "html", label: "HTML", lang: "html" },
    { key: "css", label: "CSS", lang: "css" },
    { key: "js", label: "JS", lang: "javascript" },
  ];

  return (
    <div className="ai-code-editor">
      <div className="ai-code-tabs">
        {tabs.map((tab) => (
          <div
            key={tab.key}
            className={`ai-code-tab ${activeTab === tab.key ? "active" : ""}`}
            onClick={() => onTabChange(tab.key)}
          >
            {tab.label}
          </div>
        ))}
        <Button
          primary
          size="mini"
          icon="refresh"
          content={t("AiApplyCode")}
          onClick={onApply}
          style={{ marginLeft: "auto", marginRight: 8 }}
        />
      </div>
      <div className="ai-code-body">
        <V2Editor
          lang={tabs.find((t) => t.key === activeTab).lang}
          value={currentCode[activeTab] || ""}
          onValueChange={(val) => onCodeChange(activeTab, val)}
          save={onApply}
        />
      </div>
    </div>
  );
}

class AiCreate extends React.Component {
  state = {
    loading: !templateCacheControl(DEFINITION_TYPE),
    name: "",
    messages: [],
    inputValue: "",
    isGenerating: false,
    conversationId: null,
    currentCode: { html: "", css: "", js: "" },
    flowValues: null,
    showCode: false,
    previewMode: "desktop",
    activeCodeTab: "html",
    rightTab: "preview",
    saving: false,
    toast: null,
  };

  _form = React.createRef();
  _iframe = React.createRef();
  _messagesEnd = React.createRef();

  componentDidMount() {
    this.prepare();
  }

  async findCustomHtmlTemplateKey() {
    try {
      const res = await get("/campaign/template/listV2?type=campaign");
      const templates = res.data || [];
      for (const tmpl of templates) {
        const variations = tmpl.data || [];
        for (const v of variations) {
          if (
            v &&
            v.data &&
            v.data.tags &&
            v.data.tags[0] &&
            v.data.tags[0].type === "customHtmlTag"
          ) {
            return { _key: tmpl.id, _var: v.id || "def" };
          }
        }
      }
    } catch (e) {
      // ignore
    }
    return null;
  }

  async prepare() {
    await SetUp(DEFINITION_TYPE);
    const { preData } = getFilterOptions();
    const id =
      this.props.match &&
      this.props.match.params &&
      this.props.match.params.id;

    if (id) {
      try {
        const res = await get("/campaign/getV2/" + id);
        const campaign = res.data;
        const others = campaign.data || {};
        const tag = (others.tags && others.tags[0]) || {};
        const params = tag.parameters || tag;
        const code = {
          html: (params.customHtml && params.customHtml.value) || "",
          css: (params.css && params.css.value) || "",
          js: (params.javascript && params.javascript.value) || "",
        };
        const flowValues = {
          ...preData,
          who: others.who || preData.who,
          where: others.where || preData.where,
          when: others.when || preData.when,
          trigger: others.trigger || preData.trigger,
          frequency: others.frequency || preData.frequency,
        };
        const ai = others._ai || {};
        this.setState(
          {
            loading: false,
            id: campaign.id,
            name: campaign.name || "",
            status: campaign.status,
            currentCode: code,
            flowValues,
            conversationId: ai.conversationId || null,
            _key: others._key || null,
            _var: others._var || "def",
            messages: [
              {
                role: "assistant",
                content: this.props.t("AiWelcome"),
                timestamp: Date.now(),
              },
            ],
          },
          () => this.updatePreview(code)
        );
      } catch (err) {
        this.setState({ loading: false, flowValues: preData });
      }
    } else {
      const templateKey = await this.findCustomHtmlTemplateKey();
      this.setState(
        {
          loading: false,
          flowValues: preData,
          currentCode: MOCK_CODE,
          _key: templateKey && templateKey._key,
          _var: templateKey && templateKey._var,
          messages: [
            {
              role: "assistant",
              content: this.props.t("AiWelcome"),
              timestamp: Date.now(),
            },
          ],
        },
        () => this.updatePreview(MOCK_CODE)
      );
    }
  }

  scrollToBottom = () => {
    if (this._messagesEnd.current) {
      this._messagesEnd.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.messages.length !== this.state.messages.length) {
      this.scrollToBottom();
    }
  }

  getContext() {
    const { product } = this.props;
    const settings = product && product.settings;
    return {
      domain: settings && settings.domain,
      siteType: settings && settings.siteType,
      colors: { primary: "#2185d0" },
      language: this.props.i18n && this.props.i18n.language,
      siteName: settings && settings.siteName,
    };
  }

  sendMessage = async () => {
    const { inputValue, isGenerating, conversationId, currentCode } =
      this.state;
    if (!inputValue.trim() || isGenerating) return;

    const userMessage = {
      role: "user",
      content: inputValue.trim(),
      timestamp: Date.now(),
    };

    this.setState(
      (prev) => ({
        messages: [...prev.messages, userMessage],
        inputValue: "",
        isGenerating: true,
      }),
      this.scrollToBottom
    );

    try {
      const context = this.getContext();
      let response;

      if (!conversationId) {
        response = await post("/ai/generate", {
          message: userMessage.content,
          context,
        }).then((r) => r.data);
      } else {
        response = await post("/ai/refine", {
          message: userMessage.content,
          conversationId,
          currentCode,
          context,
        }).then((r) => r.data);
      }

      if (response && response.success) {
        const assistantMessage = {
          role: "assistant",
          content: response.message,
          timestamp: Date.now(),
        };

        const newCode = response.code || currentCode;
        const newFlow = response.flow;

        this.setState(
          (prev) => {
            let flowValues = prev.flowValues;
            if (newFlow) {
              flowValues = { ...prev.flowValues };
              if (newFlow.who) flowValues.who = newFlow.who;
              if (newFlow.where) flowValues.where = newFlow.where;
              if (newFlow.when) flowValues.when = newFlow.when;
              if (newFlow.trigger) flowValues.trigger = newFlow.trigger;
              if (newFlow.frequency) flowValues.frequency = newFlow.frequency;
            }
            return {
              messages: [...prev.messages, assistantMessage],
              isGenerating: false,
              conversationId: response.conversationId || prev.conversationId,
              currentCode: newCode,
              flowValues,
            };
          },
          () => {
            this.updatePreview(this.state.currentCode);
            this.scrollToBottom();
          }
        );
      } else {
        throw new Error("API error");
      }
    } catch (err) {
      const errorMessage = {
        role: "assistant",
        content: this.props.t("AiErrorGenerate"),
        timestamp: Date.now(),
      };
      this.setState(
        (prev) => ({
          messages: [...prev.messages, errorMessage],
          isGenerating: false,
        }),
        this.scrollToBottom
      );
    }
  };

  updatePreview = (code) => {
    const frame = this._iframe.current;
    if (!frame) return;
    const doc =
      frame.contentDocument ||
      (frame.contentWindow && frame.contentWindow.document);
    if (!doc) return;

    const html = `<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8">
<meta name="viewport" content="width=device-width, initial-scale=1">
<style>${code.css || ""}</style>
</head>
<body>
${code.html || ""}
<script>${code.js || ""}<\/script>
</body>
</html>`;

    doc.open();
    doc.write(html);
    doc.close();
  };

  handleCodeChange = (type, value) => {
    this.setState(
      (prev) => ({
        currentCode: { ...prev.currentCode, [type]: value },
      }),
      () => this.updatePreview(this.state.currentCode)
    );
  };

  showToast = (message, type = "success") => {
    this.setState({ toast: { message, type } });
    setTimeout(() => this.setState({ toast: null }), 3000);
  };

  handleSave = async () => {
    const { id, name, currentCode, conversationId, status } = this.state;
    const { t } = this.props;

    if (!name.trim()) {
      this.showToast(t("AiEmptyName"), "warning");
      return;
    }

    this.setState({ saving: true });

    try {
      let flowData = {};
      if (this._form.current) {
        const formValues =
          this._form.current.values ||
          (this._form.current.state && this._form.current.state.values) ||
          {};
        flowData = _.pick(formValues, [
          "who",
          "where",
          "when",
          "trigger",
          "frequency",
        ]);
      }

      const obj = {
        name,
        status: status || "disabled",
        tags: [
          {
            name,
            type: "customHtmlTag",
            parameters: {
              customHtml: { value: currentCode.html || "" },
              css: { value: currentCode.css || "" },
              javascript: { value: currentCode.js || "" },
              htmlPosition: {
                value: "css",
                params: {
                  css: { value: "body" },
                  position: { value: "append" },
                },
              },
            },
          },
        ],
        ...flowData,
        _ai: { conversationId },
      };
      if (id) obj.id = id;
      if (this.state._key) {
        obj._key = this.state._key;
        obj._var = this.state._var || "def";
      }

      const { data: response } = await post("/campaign/save", {
        data: obj,
        type: "campaign",
      });

      if (response && response.success && response.data) {
        this.showToast(t("AiSaveSuccess"));
        if (!id && response.data.id) {
          this.setState({ id: response.data.id });
          this.props.history.replace(`/ai-create/${response.data.id}`);
        }
      }
    } catch (err) {
      console.error("Save error:", err);
      this.showToast(t("AiSaveError"), "error");
    }

    this.setState({ saving: false });
  };

  onKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      this.sendMessage();
    }
  };

  onChange = (e, { value, name }) => {
    this.setState({ [name]: value });
  };

  header() {
    const { t } = this.props;
    const { saving, currentCode, loading } = this.state;

    if (loading) {
      return (
        <Breadcrumb size="big">
          <Breadcrumb.Section as={Link} to="/actions">
            <Icon name="bullhorn" />
            {t("Actions")}
          </Breadcrumb.Section>
          <Breadcrumb.Divider icon={{ name: "asterisk", loading: true }} />
        </Breadcrumb>
      );
    }

    const hasCode = !!(currentCode.html || currentCode.css || currentCode.js);

    return (
      <>
        <Breadcrumb size="big">
          <Breadcrumb.Section className="mobile-none" as={Link} to="/actions">
            <Icon name="bullhorn" />
            {t("Actions")}
          </Breadcrumb.Section>
          <Breadcrumb.Divider className="mobile-none" icon="right chevron" />
          <Breadcrumb.Section>
            <MaterialInput
              className="actionName"
              size="mini"
              placeholder={t("Name")}
              name="name"
              onChange={this.onChange}
              value={this.state.name}
            />
          </Breadcrumb.Section>
        </Breadcrumb>
        <div
          css={`
            margin-left: auto;
            display: flex;
            align-items: center;
            .button {
              white-space: nowrap;
            }
            @media screen and (max-width: ${Responsive.onlyMobile.maxWidth -
              1}px) {
              .button {
                padding: 11px !important;
              }
              padding-left: 5px;
            }
          `}
        >
          <Button
            positive
            size="small"
            loading={saving}
            disabled={!hasCode || saving}
            onClick={this.handleSave}
          >
            {t("AiSave")}
          </Button>
        </div>
      </>
    );
  }

  renderFlowSection() {
    const { flowValues, loading } = this.state;
    const { t } = this.props;

    if (loading || !flowValues) return null;

    const { trigger, frequency, options } = getFilterOptions();

    return (
      <div className="ai-create-flow">
        <Formik
          innerRef={this._form}
          enableReinitialize
          initialValues={flowValues}
          onSubmit={() => {}}
        >
          <Form>
            <MyDivider name="Trigger" icon="lightning" />
            <TriggerSelector data={trigger} />
            <TriggerSelector data={frequency} />
            <MyDivider name={t("AiFlowTitle")} icon="setting" />
            {options.map((data, i) => (
              <FilterItem key={i} {...data} />
            ))}
          </Form>
        </Formik>
      </div>
    );
  }

  render() {
    const { t } = this.props;
    const {
      messages,
      inputValue,
      isGenerating,
      showCode,
      previewMode,
      activeCodeTab,
      currentCode,
      loading,
      rightTab,
    } = this.state;

    if (loading) {
      return (
        <Page header={this.header()}>
          <Page.Loader />
        </Page>
      );
    }

    const { toast } = this.state;

    return (
      <Page header={this.header()} flex>
        {toast && (
          <Message
            className="ai-toast"
            success={toast.type === "success"}
            warning={toast.type === "warning"}
            negative={toast.type === "error"}
            onDismiss={() => this.setState({ toast: null })}
            content={toast.message}
          />
        )}
        <div className="ai-create-page">
          {/* Left: Chat Panel */}
          <div className="ai-create-chat">
            <div className="ai-chat-messages">
              {messages.map((msg, i) => (
                <ChatMessage key={i} role={msg.role} content={msg.content} />
              ))}
              {isGenerating && (
                <ChatMessage
                  role="assistant"
                  content={t("AiGenerating")}
                  isGenerating
                />
              )}
              <div ref={this._messagesEnd} />
            </div>
            <div className="ai-chat-input">
              <textarea
                rows={1}
                value={inputValue}
                onChange={(e) => this.setState({ inputValue: e.target.value })}
                onKeyDown={this.onKeyDown}
                placeholder={t("AiChatPlaceholder")}
                disabled={isGenerating}
              />
              <Button
                primary
                icon="send"
                size="small"
                onClick={this.sendMessage}
                disabled={!inputValue.trim() || isGenerating}
                loading={isGenerating}
              />
            </div>
          </div>

          {/* Right Panel */}
          <div className="ai-create-right">
            {/* Top Tabs: Preview / Akışlar */}
            <div className="ai-right-tabs">
              <div
                className={`ai-right-tab ${
                  rightTab === "preview" ? "active" : ""
                }`}
                onClick={() => this.setState({ rightTab: "preview" })}
              >
                <Icon name="eye" /> {t("AiPreview")}
              </div>
              <div
                className={`ai-right-tab ${
                  rightTab === "flow" ? "active" : ""
                }`}
                onClick={() => this.setState({ rightTab: "flow" })}
              >
                <Icon name="setting" /> {t("AiFlowTitle")}
              </div>
            </div>

            <div
              className="ai-create-preview"
              style={rightTab !== "preview" ? { display: "none" } : undefined}
            >
              <PreviewToolbar
                previewMode={previewMode}
                showCode={showCode}
                onPreviewMode={(mode) => this.setState({ previewMode: mode })}
                onToggleCode={() =>
                  this.setState((prev) => ({ showCode: !prev.showCode }))
                }
                onReplay={() => this.updatePreview(this.state.currentCode)}
                t={t}
              />
              {showCode && (
                <CodeEditor
                  activeTab={activeCodeTab}
                  onTabChange={(tab) => this.setState({ activeCodeTab: tab })}
                  currentCode={currentCode}
                  onCodeChange={this.handleCodeChange}
                  onApply={() => this.updatePreview(this.state.currentCode)}
                  t={t}
                />
              )}
              <div
                className={`ai-preview-frame ${
                  previewMode === "mobile" ? "mobile" : ""
                }`}
                style={showCode ? { display: "none" } : undefined}
              >
                <iframe
                  ref={this._iframe}
                  title="ai-preview"
                  src="about:blank"
                />
              </div>
            </div>
            <div
              style={rightTab !== "flow" ? { display: "none" } : undefined}
            >
              {this.renderFlowSection()}
            </div>
          </div>
        </div>
      </Page>
    );
  }
}

const stateToProps = (state) => ({
  product: state.product.personalize,
});

export default connect(stateToProps)(withTranslation()(AiCreate));
